import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    document.title = "Admin · Ruby Fos";
  }, []);

  // If already authed, skip straight to the editor. Render a "checking…"
  // placeholder until /me resolves so the form doesn't flash and snap.
  useEffect(() => {
    let alive = true;
    fetch("/api/admin/me", { credentials: "same-origin" })
      .then((r) => {
        if (!alive) return;
        if (r.ok) {
          const back = (() => {
            try {
              return (
                sessionStorage.getItem("rf_admin_returnTo") || "/admin"
              );
            } catch {
              return "/admin";
            }
          })();
          navigate(back, { replace: true });
        } else {
          setChecking(false);
        }
      })
      .catch(() => alive && setChecking(false));
    return () => {
      alive = false;
    };
  }, [navigate]);

  async function onSubmit(e) {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    setError("");
    try {
      const r = await fetch("/api/admin/login", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ password }),
      });
      if (!r.ok) {
        setError(r.status === 401 ? "Incorrect password." : `Error ${r.status}`);
        setBusy(false);
        return;
      }
      const back = (() => {
        try {
          return sessionStorage.getItem("rf_admin_returnTo") || "/admin";
        } catch {
          return "/admin";
        }
      })();
      try {
        sessionStorage.removeItem("rf_admin_returnTo");
      } catch {}
      navigate(back, { replace: true });
    } catch (err) {
      setError("Network error.");
      setBusy(false);
    }
  }

  if (checking) {
    return (
      <div
        style={{
          minHeight: "100vh",
          background: "#0c0c0c",
          color: "#888",
          display: "grid",
          placeItems: "center",
          fontFamily: "system-ui, sans-serif",
          fontSize: "0.9rem",
        }}
      >
        checking…
      </div>
    );
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#0c0c0c",
        color: "#f4ece0",
        display: "grid",
        placeItems: "center",
        fontFamily: "system-ui, -apple-system, sans-serif",
        padding: "1.5rem",
      }}
    >
      <form
        onSubmit={onSubmit}
        style={{
          width: "100%",
          maxWidth: 360,
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
        }}
      >
        <h1
          style={{
            fontSize: "1.4rem",
            fontWeight: 500,
            margin: 0,
            letterSpacing: "0.04em",
          }}
        >
          Admin
        </h1>
        <p style={{ margin: 0, color: "#888", fontSize: "0.9rem" }}>
          Sign in to edit site content.
        </p>
        <input
          type="password"
          autoFocus
          autoComplete="current-password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={{
            background: "#161616",
            border: "1px solid #2a2a2a",
            color: "#f4ece0",
            padding: "0.7rem 0.9rem",
            fontSize: "1rem",
            borderRadius: 4,
            outline: "none",
          }}
        />
        <button
          type="submit"
          disabled={busy || !password}
          style={{
            background: busy ? "#2a2a2a" : "#f4ece0",
            color: busy ? "#888" : "#0c0c0c",
            border: "none",
            padding: "0.7rem 0.9rem",
            fontSize: "0.95rem",
            borderRadius: 4,
            cursor: busy || !password ? "default" : "pointer",
            fontWeight: 500,
            letterSpacing: "0.04em",
          }}
        >
          {busy ? "signing in…" : "Sign in"}
        </button>
        {error && (
          <div style={{ color: "#e88", fontSize: "0.85rem" }}>{error}</div>
        )}
      </form>
    </div>
  );
}
